var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwsj"},[_c('img',{attrs:{"src":_vm.icon,"width":_vm.imgW,"height":_vm.imgH}}),_c('div',{staticStyle:{"color":"#999","font-size":"12px","margin-top":"5px"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }